import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { eachDayOfInterval, isEqual, isSameMonth, lastDayOfMonth, lastDayOfWeek, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { useState } from 'react';
import CalendarCell from '../CalendarCell/index';
import { createSchedule } from '../utils/createSchedule';
const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
function MonthView(props) {
    const { schedule = [], date, isEditable, source, } = props;
    const [showSchedule, setShowschedule] = useState();
    const scheduleDays = createSchedule(schedule);
    const weekRenderer = () => {
        return (_jsx(Box, Object.assign({ sx: {
                gridColumn: '1 / -1',
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                background: '#fff',
                borderRadius: '5px',
            } }, { children: weekdays.map((weekday) => (_jsx(Typography, Object.assign({ variant: "h3", sx: {
                    height: '40px',
                    display: 'grid',
                    justifyContent: 'right',
                    alignItems: 'center',
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: '#DCDFE4',
                    paddingRight: '15px'
                } }, { children: weekday }), weekday))) })));
    };
    const renderDays = () => {
        const daysInMonth = eachDayOfInterval({
            start: startOfWeek(startOfMonth(date)),
            end: lastDayOfWeek(lastDayOfMonth(date))
        });
        return daysInMonth.map((day, idx) => {
            let disabled = !isSameMonth(day, date);
            let isToday = isEqual(day, startOfDay(new Date()));
            let currentDaySchedule = scheduleDays[new Date(day).toDateString()];
            return (_jsx(Box, Object.assign({ sx: {
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: '#DCDFE4',
                    minHeight: '98px',
                    minWidth: "134px",
                    padding: '10px 10px 0px 10px'
                } }, { children: _jsx(CalendarCell, { disabled: disabled, date: day, isToday: isToday, schedule: currentDaySchedule, isEditable: isEditable, showSchedule: showSchedule, source: source, setShowschedule: setShowschedule, cellType: "month" }, idx) }), `${idx}`));
        });
    };
    return (_jsxs(Box, Object.assign({ sx: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginTop: '12px',
            height: 'fit-content'
        } }, { children: [weekRenderer(), renderDays()] })));
}
export default MonthView;
